
const m = window.require("embercom/vendor/intercom/storage");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
